<template>
  <div>
    <template v-if="hasMultipleWizards">
      <v-menu content-class="white" bottom transition="slide-y-transition" :disabled="disabled">
      <v-tooltip bottom slot="activator">
        <v-btn icon slot="activator" :disabled="disabled">
          <v-icon>add</v-icon>
        </v-btn>
        <span>{{ $t('message.content.selector.add')}}</span>
      </v-tooltip>
      <v-list>
        <v-list-tile
          v-for="wizard in wizardConfig"
          :key="wizard.name"
          @click.stop="selectWizard(wizard)">
          <v-list-tile-avatar v-if="wizard.icon">
            <v-icon v-html="wizard.icon"></v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>{{ $t('message.wizard.' + wizard.name) }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    </template>

    <template v-else>
      <v-tooltip bottom>
        <v-btn icon slot="activator" :disabled="disabled" @click="selectWizard(wizardConfig[0])">
          <v-icon>add</v-icon>
        </v-btn>
        <span>{{ $t('message.content.selector.add')}}</span>
      </v-tooltip>
    </template>

    <component v-if="selectedWizard"
               :is="wizardComponent"
               :active="showDialog"
               :entity="selectedWizard.name"
               :config="selectedWizard"
               @dismiss="closeWizard"
               @entityCreated="$emit('entityCreated', $event)"
    />
  </div>
</template>

<script>
import { delay } from '@/utils';

export default {
  name: 'nx-content-selector-wizard',
  components: {
    NxEntityWizard: () => import('@/modules/entity/wizard/Wizard'),
  },
  data() {
    return {
      showDialog: false,
      selectedWizard: null,
    };
  },
  props: {
    wizards: {
      type: Array,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    hasMultipleWizards() {
      return this.wizards.length > 1;
    },
    wizardConfig() {
      return this.wizards.map(this.$store.getters.getWizard);
    },
    wizardComponent() {
      if (!this.wizardConfig) {
        return null;
      }
      if (!this.wizardConfig.component) {
        // If none configured, return the entity wizard by default;
        return 'NxEntityWizard';
      }
      // Return the configured wizard
      return this.wizardConfig.component;
    },
  },
  methods: {
    async selectWizard(wizard) {
      this.selectedWizard = wizard;
      await delay(100);
      this.showDialog = true;
    },
    closeWizard() {
      this.selectedWizard = null;
      this.showDialog = false;
    },
  },
};
</script>
